/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmMcpVaultListCredentials } from "../../funcs/llmMcpVaultListCredentials.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListMcpCredentialsRequest$inboundSchema,
};

export const tool$llmMcpVaultListCredentials: ToolDefinition<typeof args> = {
  name: "llm-mcp-vault-list-credentials",
  description: `List MCP credentials

Lists encrypted credential metadata for a user-owned MCP server.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmMcpVaultListCredentials(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
